module.exports = __webpack_public_path__ + "img/IMG_1149_L_Wood_MockedUp.3ff78db1.jpg";